export default {
  "date": {
    "today": "today",
    "tomorrow": "tomorrow"
  }
};
